const ADMIN_WIRTUALNA_POLSKA_MEDIA = 'WPM';
const ADMIN_WIRTUALNA_POLSKA_HOLDING = 'GWP';
const ADMIN_TRUSTED_PARTNERS = 'TP';

const activeAdmins = [/* ADMIN_WIRTUALNA_POLSKA_MEDIA, ADMIN_WIRTUALNA_POLSKA_HOLDING, */ ADMIN_TRUSTED_PARTNERS];

module.exports = { ADMIN_WIRTUALNA_POLSKA_MEDIA, ADMIN_WIRTUALNA_POLSKA_HOLDING, ADMIN_TRUSTED_PARTNERS, activeAdmins };
